/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { ContentAiUpdateStationConfigMutationRequest, ContentAiUpdateStationConfigMutationResponse, ContentAiUpdateStationConfigPathParams, ContentAiUpdateStationConfig401, ContentAiUpdateStationConfig403 } from "../models/ContentAiUpdateStationConfig";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { contentAiUpdateStationConfig } from "../axios/contentAiUpdateStationConfig";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const contentAiUpdateStationConfigMutationKey = () => [{ url: '/content-ai/v1/station-config/:stationId' }] as const

export type ContentAiUpdateStationConfigMutationKey = ReturnType<typeof contentAiUpdateStationConfigMutationKey>

export function contentAiUpdateStationConfigMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ContentAiUpdateStationConfigMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = contentAiUpdateStationConfigMutationKey()
        return mutationOptions<ContentAiUpdateStationConfigMutationResponse, ResponseErrorConfig<ContentAiUpdateStationConfig401 | ContentAiUpdateStationConfig403>, {stationId: ContentAiUpdateStationConfigPathParams["stationId"], data: ContentAiUpdateStationConfigMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ stationId, data }) => {
            return contentAiUpdateStationConfig(stationId, data, config)
          },
        })

}

/**
 * @summary Update station config
 * {@link /content-ai/v1/station-config/:stationId}
 */
export function useContentAiUpdateStationConfig<TContext>(options: 
{
  mutation?: UseMutationOptions<ContentAiUpdateStationConfigMutationResponse, ResponseErrorConfig<ContentAiUpdateStationConfig401 | ContentAiUpdateStationConfig403>, {stationId: ContentAiUpdateStationConfigPathParams["stationId"], data: ContentAiUpdateStationConfigMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ContentAiUpdateStationConfigMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? contentAiUpdateStationConfigMutationKey()

          const baseOptions = contentAiUpdateStationConfigMutationOptions(config) as UseMutationOptions<ContentAiUpdateStationConfigMutationResponse, ResponseErrorConfig<ContentAiUpdateStationConfig401 | ContentAiUpdateStationConfig403>, {stationId: ContentAiUpdateStationConfigPathParams["stationId"], data: ContentAiUpdateStationConfigMutationRequest}, TContext>
          

          return useMutation<ContentAiUpdateStationConfigMutationResponse, ResponseErrorConfig<ContentAiUpdateStationConfig401 | ContentAiUpdateStationConfig403>, {stationId: ContentAiUpdateStationConfigPathParams["stationId"], data: ContentAiUpdateStationConfigMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ContentAiUpdateStationConfigMutationResponse, ResponseErrorConfig<ContentAiUpdateStationConfig401 | ContentAiUpdateStationConfig403>, {stationId: ContentAiUpdateStationConfigPathParams["stationId"], data: ContentAiUpdateStationConfigMutationRequest}, TContext>
      
}